/* @flow */

import "@babel/polyfill";
import "whatwg-fetch";
import "url-search-params-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "../packages/sandbox_signup/src/App.js";
import { MemoryRouter } from "react-router-dom";
import { init } from "@sentry/browser";
import { Kount } from "../packages/signups/src/Kount";

const configNode = document.querySelector("#sandboxFormConfig");
const container = document.querySelector(".sandbox_signup");

if (configNode !== null && container !== null) {
  const { sentry, countries, config, kount_id: kountId } = JSON.parse(
    configNode.textContent
  );

  let countryCode = (
    new URLSearchParams(window.location.search).get("countryCode") || "USA"
  ).toUpperCase();

  if (countryCode.length === 2) {
    countryCode = countries.find(country => country[2] === countryCode)[1];
  }

  Kount.initialize(kountId);

  init({
    ...sentry,
    attachStacktrace: true,
    dsn: "https://18f46a4c79944aa9a75172b3c631ee36@sentry.io/1725694",
    enabled: sentry.environment !== "test",
    whitelistUrls: [`${window.location.hostname}/packs`]
  });

  ReactDOM.render(
    <MemoryRouter initialEntries={[`${location.pathname}${location.search}`]}>
      <App countryCode={countryCode} countries={countries} config={config} />
    </MemoryRouter>,
    container
  );
}
